import React from "react";
import "./ExpertiseCard.css";

const ExpertiseCard = ({ icon, title, description }) => {
  return (
    <div className="expertise-card text-center p-4 d-flex flex-column align-items-center">
      <div className="expertise-icon mb-3">
        <img src={icon} alt={title} />
      </div>
      <h5 className="expertise-title mb-2">{title}</h5>
      <p className="expertise-desc">{description}</p>
    </div>
  );
};

export default ExpertiseCard;
